export interface SlackAPIResponse {
  ok: boolean;
  error?: string;
  headers: Headers;
}
